module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-1.dbf8f9a2.jpg";